import React from 'react';
import MapMask from '@/components/MapMask';
import { Modal, message } from 'antd';

interface SelectAddressForMapProps {
  onChange?: (point: any) => void;
  value?: any;
  visible?: boolean
  onCancel?: () => void
}
export default class SelectAddressForMap extends React.Component<SelectAddressForMapProps, any>{
  static getDerivedStateFromProps(nextProps: SelectAddressForMapProps, prevState: any) {
    if ('value' in nextProps || 'visible' in nextProps) {
      return {
        value: nextProps.visible === false ? undefined : nextProps.value || undefined,
        visible: nextProps.visible === undefined ? prevState.visible : nextProps.visible,
      }
    }
    return null;
  }

  constructor(props: SelectAddressForMapProps) {
    super(props);
    this.state = {
      visible: false,
      value: undefined,
    }
  }

  onChange = (value: any) => {
    if (this.props.onChange) {
      this.props.onChange(value);
      // this.setState({ visible: false });
    } else {
      this.setState({
        value: value,
        visible: false,
      })
    }
  }
  open = () => this.setState({ visible: true })

  cancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel()
    } else {
      this.setState({ visible: false })
    }
  }
  render() {
    const { visible, value } = this.state;
    return <Modal destroyOnClose width={830} visible={visible} title='地址选择' onCancel={this.cancel} footer={false}>
      {
        visible && <MapMask defaultValue={value} onChange={this.onChange} onCancel={this.cancel} />
      }
      {/* <Input size={size} value={value.district ? `${value.district}${value.address || ''}${value.name || ''}` : value.name ? `${value.pname || ''}${value.cityname || ''}${value.adname || ''}${value.address || ''}${value.name || ''}` : undefined} onFocus={this.open}/> */}
    </Modal>
  }
}

// class Point{
//   adcode

//   address
//   adname
//   citycode
//   cityname
//   name
//   pcode

//   pname


//   constructor(obj){
//     this.name = obj.name;
//   }
// }